import { useRef, useState } from "react";
import { toast } from "sonner";
import { useContent } from "@/contexts/ContentContext";
import { renderModalityIcon } from "@/components/IconLibrary";
import { IconPickerModal } from "@/components/IconPickerModal";
import { CMS } from "@/constants/testIds/cms";

export function ModalityIconSlot({ index }) {
  const { editMode, getByPath, setPath, uploadImage } = useContent();
  const value = getByPath(`modalities.${index}.icon`);
  const [pickerOpen, setPickerOpen] = useState(false);
  const inputRef = useRef(null);

  async function handleFile(e) {
    const file = e.target.files[0];
    e.target.value = "";
    if (!file) return;
    try {
      const url = await uploadImage(file);
      setPath(`modalities.${index}.icon`, url);
    } catch {
      toast.error("Image upload failed, try again");
    }
  }

  return (
    <div className="mod-icon-wrap">
      {renderModalityIcon(value, index)}
      {editMode && (
        <div className="icon-slot-actions">
          <button type="button" onClick={() => setPickerOpen(true)} data-testid={`${CMS.modIconLibraryButton}-${index}`}>
            Choose icon
          </button>
          <button type="button" onClick={() => inputRef.current.click()} data-testid={`${CMS.modIconEdit}-${index}`}>
            Upload
          </button>
          <input ref={inputRef} type="file" accept="image/png,image/jpeg,image/webp,image/gif" hidden onChange={handleFile} />
        </div>
      )}
      <IconPickerModal
        open={pickerOpen}
        onOpenChange={setPickerOpen}
        onSelect={(name) => {
          setPath(`modalities.${index}.icon`, `lucide:${name}`);
          setPickerOpen(false);
        }}
        onReset={() => {
          setPath(`modalities.${index}.icon`, null);
          setPickerOpen(false);
        }}
      />
    </div>
  );
}
